import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { jobOffer } from 'job/model/job-offer.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { JobOfferOutput } from '../model/job-offer.output';

export interface UpdateJobOfferDocumentParams {
	readonly jobOfferId: string;
	readonly documentUrl: string;
}

@Injectable({ providedIn: 'root' })
export class UpdateJobOfferDocumentApiMutation extends ApiMutation<
	JobOfferOutput,
	UpdateJobOfferDocumentParams
> {
	client = 'iam';
	document = gql`
		mutation UpdateJobOfferDocument($documentUrl: String!, $jobOfferId: UUID!) {
			updateJobOfferDocument(jobOfferId: $jobOfferId, documentUrl: $documentUrl) {
				...JobOffer
			}
		}
		${jobOffer}
	`;
	method = 'updateJobOfferDocument';
}
